/**
 * Converia.Core.module
 *
 * Converia.SiteStructure.FormHandler
 */

Converia.Core.module('Converia.SiteStructure.Form', function () {
    /**
     * Form
     * 
     * @param inputElement
     * @constructor
     */
    var Form = function (inputElement) {
        this.inputElement = inputElement;
        this.form = $(inputElement).closest('form').get(0);
    };

    /**
     * Form.prototype.getDomElement
     * 
     * @returns {object}
     */
    Form.prototype.getDomElement = function () {
        return this.form;
    };

    /**
     * Form.prototype.getInputElement
     * 
     * @returns {object}
     */
    Form.prototype.getInputElement = function () {
        return this.inputElement;
    };

    return Form;
});